import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Capabilities } from "./components/Capabilities";
import { Approach } from "./components/Approach";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

export default function App() {
    const lenisRef = useRef(null);

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
        lenisRef.current = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    const scrollTo = (target) => {
        if (lenisRef.current) {
            lenisRef.current.scrollTo(target, { offset: -70, duration: 1.4 });
        }
    };

    return (
        <div id="top" className="min-h-screen bg-[#FAFAFA] text-slate-900 antialiased">
            <Nav onNavigate={scrollTo} />
            <main>
                <Hero onNavigate={scrollTo} />
                <Marquee />
                <Capabilities />
                <Approach />
                <Contact />
            </main>
            <Footer onNavigate={scrollTo} />
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#0A1B3F",
                        color: "#fff",
                        border: "1px solid rgba(255,255,255,0.14)",
                        borderRadius: "4px",
                    },
                }}
            />
        </div>
    );
}
